<template>
  <div class="mc-trackvideo-card--sleep">{{ $t('trackVideo.state.sleep', { seconds }) }}</div>
</template>
<script>
import videoSleep from '@/mixin/video-sleep'

export default {
  name: 'SleepState',
  mixins: [videoSleep],
}
</script>
